import React from 'react'

let config = [
  {
    type: 'columns',
    itemType: 'element',
    category: 'content',
    title: 'Spalten Element',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.583" viewBox="0 0 24 23.583"><path d="M34.428,12.59H25.189a.3.3,0,0,0-.3.3.3.3,0,0,0,.3.3h9.239a.3.3,0,0,0,0-.6Z" transform="translate(-13.084 -6.618)"/><path d="M34.428,19.56H25.189a.3.3,0,0,0,0,.6h9.239a.3.3,0,0,0,0-.6Z" transform="translate(-13.084 -10.283)"/><path d="M34.428,26.53H25.189a.3.3,0,0,0,0,.6h9.239a.3.3,0,0,0,0-.6Z" transform="translate(-13.084 -13.947)"/><path d="M12.483,19.886l.076-.052.028-.033h0a.171.171,0,0,0,0-.043V19.7h0a.1.1,0,0,0,0-.028v-6.74l-.024-.028v-.028H12.54l-.133-.071H5.141l-.076.057h0v.028A.1.1,0,0,0,5,12.895v.062H5a.1.1,0,0,0,0,.028v.066H5v6.692a.071.071,0,0,1,0,.028v.033l.028.028.076.052H12.45ZM11.369,13.3,8.817,15.949,6.265,13.3Zm-5.791.261,2.7,2.746-2.7,2.756Zm.688,5.753,2.552-2.651,2.552,2.651Zm5.791-.251-2.7-2.751,2.7-2.746Z" transform="translate(-2.627 -6.729)"/><path d="M5.227,34.06H23.915a.3.3,0,0,0,0-.593H5.227a.3.3,0,1,0,0,.593Z" transform="translate(-2.571 -17.592)"/><path d="M5.269,41.248H23.957a.3.3,0,0,0,0-.6H5.269a.3.3,0,0,0,0,.6Z" transform="translate(-2.613 -21.369)"/><circle cx="0.299" cy="0.299" r="0.299" transform="translate(20.964 1.57)"/><circle cx="0.299" cy="0.299" r="0.299" transform="translate(19.394 1.57)"/><circle cx="0.299" cy="0.299" r="0.299" transform="translate(17.824 1.57)"/><path d="M24,22.349V1.081A1.1,1.1,0,0,0,22.914,0H1.1A1.1,1.1,0,0,0,0,1.086V22.5a1.1,1.1,0,0,0,1.086,1.081H22.9A1.228,1.228,0,0,0,24,22.349ZM.6,1.081A.474.474,0,0,1,1.072.607H22.89a.474.474,0,0,1,.474.474V3.14H.6ZM1.072,22.99A.474.474,0,0,1,.6,22.515V3.738H23.4V22.349c0,.256-.2.64-.474.64Z"/></svg>,
    settings: {
      sections: [
        {
          headline: 'Spalten',
          fields: [
            {
              type: 'repeater',
              name: 'columns',
              label: 'Spalten',
              addItemLabel: 'Spalte hinzufügen',
              maxItems: 4,
              fields: [
                {
                  type: 'column_elements',
                  name: 'elements',
                  label: 'Elemente'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'text',
    itemType: 'column-element',
    category: 'content',
    title: 'Text',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.583" viewBox="0 0 24 23.583"><path d="M34.428,12.59H25.189a.3.3,0,0,0-.3.3.3.3,0,0,0,.3.3h9.239a.3.3,0,0,0,0-.6Z" transform="translate(-13.084 -6.618)"/><path d="M34.428,19.56H25.189a.3.3,0,0,0,0,.6h9.239a.3.3,0,0,0,0-.6Z" transform="translate(-13.084 -10.283)"/><path d="M34.428,26.53H25.189a.3.3,0,0,0,0,.6h9.239a.3.3,0,0,0,0-.6Z" transform="translate(-13.084 -13.947)"/><path d="M12.483,19.886l.076-.052.028-.033h0a.171.171,0,0,0,0-.043V19.7h0a.1.1,0,0,0,0-.028v-6.74l-.024-.028v-.028H12.54l-.133-.071H5.141l-.076.057h0v.028A.1.1,0,0,0,5,12.895v.062H5a.1.1,0,0,0,0,.028v.066H5v6.692a.071.071,0,0,1,0,.028v.033l.028.028.076.052H12.45ZM11.369,13.3,8.817,15.949,6.265,13.3Zm-5.791.261,2.7,2.746-2.7,2.756Zm.688,5.753,2.552-2.651,2.552,2.651Zm5.791-.251-2.7-2.751,2.7-2.746Z" transform="translate(-2.627 -6.729)"/><path d="M5.227,34.06H23.915a.3.3,0,0,0,0-.593H5.227a.3.3,0,1,0,0,.593Z" transform="translate(-2.571 -17.592)"/><path d="M5.269,41.248H23.957a.3.3,0,0,0,0-.6H5.269a.3.3,0,0,0,0,.6Z" transform="translate(-2.613 -21.369)"/><circle cx="0.299" cy="0.299" r="0.299" transform="translate(20.964 1.57)"/><circle cx="0.299" cy="0.299" r="0.299" transform="translate(19.394 1.57)"/><circle cx="0.299" cy="0.299" r="0.299" transform="translate(17.824 1.57)"/><path d="M24,22.349V1.081A1.1,1.1,0,0,0,22.914,0H1.1A1.1,1.1,0,0,0,0,1.086V22.5a1.1,1.1,0,0,0,1.086,1.081H22.9A1.228,1.228,0,0,0,24,22.349ZM.6,1.081A.474.474,0,0,1,1.072.607H22.89a.474.474,0,0,1,.474.474V3.14H.6ZM1.072,22.99A.474.474,0,0,1,.6,22.515V3.738H23.4V22.349c0,.256-.2.64-.474.64Z"/></svg>,
    helpVideo: '448967860',
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'wysiwyg',
              name: 'text',
              label: 'Text'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'image',
    itemType: 'column-element',
    category: 'content',
    title: 'Bild',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18.028" viewBox="0 0 24 18.028"><path d="M24,18.028H0V0H24ZM.614,17.414H23.386V.614H.614Z" /><path d="M8.149,14.611,4.3,10.76l-3.7,3.7L.16,14.029,4.3,9.891l3.851,3.851,7.825-7.825,7.936,7.936-.434.434-7.5-7.5Z" /><path d="M8.233,9.014A3.237,3.237,0,1,1,11.47,5.777,3.237,3.237,0,0,1,8.233,9.014Zm0-5.86a2.623,2.623,0,1,0,2.623,2.623A2.623,2.623,0,0,0,8.233,3.153Z" /></svg>,
    helpVideo: '448967150',
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'image',
              name: 'image',
              label: 'Bild'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'audio',
    itemType: 'column-element',
    category: 'content',
    title: 'Audio',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21.822" viewBox="0 0 24 21.822"><path d="M10.459,21.45A1.008,1.008,0,0,1,9.8,21.2h0L5.333,16.484H1.017A1.018,1.018,0,0,1,0,15.434V9.473A1.018,1.018,0,0,1,1.017,8.455h4.3L9.767,3.7a1.022,1.022,0,0,1,1.715.744v16.02a1.008,1.008,0,0,1-.6.942,1.027,1.027,0,0,1-.424.047Zm-.283-.674a.471.471,0,0,0,.74-.349V4.408a.471.471,0,0,0-.754-.339l-4.6,4.952H1.017a.471.471,0,0,0-.471.471v5.942a.471.471,0,0,0,.471.471H5.559Z" transform="translate(0.001 -1.811)"/><path d="M28.425,22.724a.311.311,0,0,0,.226-.033,4.175,4.175,0,0,0,.678-.561,3.9,3.9,0,0,0,0-5.5,3.8,3.8,0,0,0-.721-.57.273.273,0,0,0-.155-.047h-.071a.273.273,0,0,0-.184.137.283.283,0,0,0-.038.221.292.292,0,0,0,.137.188,3.31,3.31,0,0,1,.608,5.155,3.543,3.543,0,0,1-.57.471.273.273,0,0,0-.132.184.292.292,0,0,0,.038.226A.306.306,0,0,0,28.425,22.724Z" transform="translate(-14.887 -8.465)"/><path d="M36.558,15.152A8.067,8.067,0,0,0,32.238,7.99a.278.278,0,0,0-.137,0h-.09a.316.316,0,0,0-.179.151.3.3,0,0,0,.127.4,7.463,7.463,0,0,1,1.819,11.883,7.341,7.341,0,0,1-1.8,1.333.283.283,0,0,0-.146.174.292.292,0,0,0,.024.226.283.283,0,0,0,.174.146.311.311,0,0,0,.226,0h0A8.185,8.185,0,0,0,34.2,20.868,8.01,8.01,0,0,0,36.558,15.152Z" transform="translate(-16.816 -4.22)"/><path d="M36.554,21.772A12.312,12.312,0,0,0,36.483.032.278.278,0,0,0,36.323,0a.3.3,0,0,0-.264.16.292.292,0,0,0-.024.226.283.283,0,0,0,.146.174,11.845,11.845,0,0,1,2.827,2.092,11.713,11.713,0,0,1-2.742,18.593.306.306,0,0,0-.146.179.292.292,0,0,0,0,.226.3.3,0,0,0,.433.123Z" transform="translate(-19.049 0.003)"/></svg>,
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'audio',
              name: 'audio',
              label: 'Audio'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'video',
    itemType: 'element',
    category: 'content',
    title: 'Video',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18.028" viewBox="0 0 24 18.028"><path d="M24,18.028H0V0H24ZM.614,17.414H23.386V.614H.614Z" /><path d="M8.149,14.611,4.3,10.76l-3.7,3.7L.16,14.029,4.3,9.891l3.851,3.851,7.825-7.825,7.936,7.936-.434.434-7.5-7.5Z" /><path d="M8.233,9.014A3.237,3.237,0,1,1,11.47,5.777,3.237,3.237,0,0,1,8.233,9.014Zm0-5.86a2.623,2.623,0,1,0,2.623,2.623A2.623,2.623,0,0,0,8.233,3.153Z" /></svg>,
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'video',
              name: 'video',
              label: 'Video'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'introslider',
    itemType: 'element',
    category: 'content',
    title: 'Introslider',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="34.677" height="21" viewBox="0 0 41.677 21"><path d="M2536.033,767h24.246a1.357,1.357,0,0,0,1.246-1.438V747.438A1.357,1.357,0,0,0,2560.28,746h-24.433a1.357,1.357,0,0,0-1.246,1.438v18.123A1.512,1.512,0,0,0,2536.033,767Zm24.246-20.209a.606.606,0,0,1,.561.647h0v18.123a.606.606,0,0,1-.561.647h-24.246c-.312,0-.748-.288-.748-.647V747.438a.606.606,0,0,1,.561-.647h24.433Z" transform="translate(-2526.975 -746)"/><path d="M2580.3,766.5c-.1,0-.3-.1-.4-.1a.483.483,0,0,1,0-.7l4-4-4-4a.495.495,0,0,1,.7-.7l4.1,4.1a.91.91,0,0,1,0,1.2l-4.1,4.1C2580.5,766.4,2580.4,766.5,2580.3,766.5Z" transform="translate(-2543.249 -750.551)"/><path d="M2531.7,766.5a.6.6,0,0,1-.4-.1l-4.1-4.1a.91.91,0,0,1,0-1.2l4.1-4.1a.495.495,0,0,1,.7.7h0l-4,4,4,4a.483.483,0,0,1,0,.7h0a1.009,1.009,0,0,1-.3.1Z" transform="translate(-2526.975 -750.551)"/><line x2="25.026" y2="18.8" transform="translate(8.225 0.8)" strokeMiterlimit="10" strokeWidth="1"/><line x1="25.026" y2="18.8" transform="translate(8.125 1.3)" strokeMiterlimit="10" strokeWidth="1"/></svg>,
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'repeater',
              name: 'slides',
              label: 'Slides',
              addItemLabel: 'Slide hinzufügen',
              fields: [
                {
                  type: 'image',
                  name: 'image',
                  label: 'Bild'
                },
                {
                  type: 'textarea',
                  name: 'headline',
                  label: 'Titel'
                },
                {
                  type: 'textarea',
                  name: 'text',
                  label: 'Text'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'instruction',
    itemType: 'element',
    category: 'content',
    title: 'Anweisung',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.63" viewBox="0 0 24 23.63"><path d="M6.061,23.63V20.048H2.812A2.812,2.812,0,0,1,0,17.391V2.658A2.658,2.658,0,0,1,2.658,0H21.342A2.658,2.658,0,0,1,24,2.658V17.391a2.658,2.658,0,0,1-2.658,2.658H10.561ZM2.658.563a2.1,2.1,0,0,0-2.1,2.1V17.391a2.245,2.245,0,0,0,2.25,2.1h3.8v2.981l3.75-2.981H21.342a2.1,2.1,0,0,0,2.1-2.1V2.658a2.1,2.1,0,0,0-2.1-2.1Z" transform="translate(0 0)"/><path d="M25.562,16.754a.281.281,0,0,1-.563,0v-9.4a.281.281,0,1,1,.562,0Z" transform="translate(-13.281 -3.756)"/><path d="M25.562,32.848a.281.281,0,0,1-.563,0v-.5a.281.281,0,1,1,.562,0Z" transform="translate(-13.281 -17.037)"/></svg>,
    settings: {
      sections: [
        {
          headline: 'Bild',
          fields: [
            {
              type: 'image',
              name: 'image',
              label: 'Bild'
            }
          ]
        },
        {
          headline: 'Audio',
          fields: [
            {
              type: 'audio',
              name: 'audio',
              label: 'Audio'
            }
          ]
        },
        {
          headline: 'Text',
          fields: [
            {
              type: 'textarea',
              name: 'text',
              label: 'Text'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'teasers',
    itemType: 'element',
    category: 'content',
    title: 'Teaser',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24.124" viewBox="0 0 24 24.124"><path d="M11.225,22.887V1.084A1.1,1.1,0,0,0,10.136,0H1.1A1.1,1.1,0,0,0,0,1.089v21.95a1.1,1.1,0,0,0,1.089,1.084h9.037A1.232,1.232,0,0,0,11.225,22.887ZM.6,1.084A.476.476,0,0,1,1.075.609h9.037a.476.476,0,0,1,.476.476v21.8c0,.257-.2.642-.476.642H1.075A.476.476,0,0,1,.6,23.053Z"/><path d="M7,4.7H11.6a.285.285,0,1,1,0,.571H7A.285.285,0,0,1,7,4.7Z" transform="translate(-3.519 -2.465)"/><rect width="0.571" height="25.355" transform="translate(0.354 0.595) rotate(-23.2)"/><rect width="25.355" height="0.571" transform="translate(0.357 23.679) rotate(-66.8)"/><path d="M5,28.7h6.036a.285.285,0,0,1,0,.571H5A.285.285,0,0,1,5,28.7Z" transform="translate(-2.47 -15.05)"/><path d="M5,33.7h6.036a.285.285,0,0,1,0,.571H5A.285.285,0,0,1,5,33.7Z" transform="translate(-2.47 -17.672)"/><path d="M5,38.7h6.036a.285.285,0,1,1,0,.571H5A.285.285,0,1,1,5,38.7Z" transform="translate(-2.47 -20.293)"/><path d="M5,43.7h6.036a.285.285,0,0,1,0,.571H5A.285.285,0,0,1,5,43.7Z" transform="translate(-2.47 -22.915)"/><path d="M38.1,22.887V1.084A1.1,1.1,0,0,0,37.011,0H27.974A1.1,1.1,0,0,0,26.89,1.089v21.95a1.1,1.1,0,0,0,1.084,1.084h9.037A1.232,1.232,0,0,0,38.1,22.887ZM27.47,1.084a.476.476,0,0,1,.476-.476h9.037a.476.476,0,0,1,.476.476v7.3H27.47Zm.476,22.445a.476.476,0,0,1-.476-.476V8.98H37.5V22.887c0,.257-.2.642-.476.642Z" transform="translate(-14.101)"/><path d="M32,23.7h6.036a.285.285,0,1,1,0,.571H32a.285.285,0,1,1,0-.571Z" transform="translate(-16.628 -12.428)"/><path d="M32,28.7h6.036a.285.285,0,1,1,0,.571H32a.285.285,0,1,1,0-.571Z" transform="translate(-16.628 -15.05)"/><path d="M32,33.7h6.036a.285.285,0,1,1,0,.571H32a.285.285,0,1,1,0-.571Z" transform="translate(-16.628 -17.672)"/><path d="M32,38.7h6.036a.285.285,0,1,1,0,.571H32a.285.285,0,1,1,0-.571Z" transform="translate(-16.628 -20.293)"/><path d="M32,43.7h6.036a.285.285,0,0,1,0,.571H32a.285.285,0,0,1,0-.571Z" transform="translate(-16.628 -22.915)"/><rect width="0.571" height="12.851" transform="matrix(0.629, -0.777, 0.777, 0.629, 13.316, 0.706)"/><rect width="12.851" height="0.571" transform="translate(13.312 8.347) rotate(-38.96)"/></svg>,
    helpVideo: '448967799',
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'repeater',
              name: 'teasers',
              label: 'Teaser',
              addItemLabel: 'Teaser hinzufügen',
              maxItems: 3,
              fields: [
                {
                  type: 'teaser_types',
                  name: 'type',
                  label: 'Teaserauswahl',
                  defaultValue: 'small-image-text'
                },
                {
                  type: 'textarea',
                  name: 'headline',
                  label: 'Titel'
                },
                {
                  type: 'textarea',
                  name: 'text',
                  label: 'Text'
                },
                {
                  type: 'image',
                  name: 'image',
                  label: 'Bild'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                },
                {
                  settings: {}
                },
                {
                  settings: {}
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'hotspots',
    itemType: 'element',
    category: 'content',
    title: 'Hotspots',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.15,42.966a3.633,3.633,0,1,1,1.308-7.031l.248.108-.239.506-.216-.089a3.067,3.067,0,1,0,.919.553l.37-.427A3.633,3.633,0,0,1,6.15,42.952Z" transform="translate(-1.35 -18.966)"/><rect width="0.563" height="3.075" transform="translate(4.584 18.769)"/><rect width="3.075" height="0.563" transform="translate(3.328 20.025)"/><path d="M6.061,19.106V13.95H2.813A2.812,2.812,0,0,1,0,11.3V2.658A2.658,2.658,0,0,1,2.658,0H21.342A2.658,2.658,0,0,1,24,2.658V11.3a2.658,2.658,0,0,1-2.658,2.658H10.608ZM2.658.563a2.1,2.1,0,0,0-2.1,2.1V11.3a2.245,2.245,0,0,0,2.25,2.1h3.8v4.219l3.727-4.219H21.342a2.1,2.1,0,0,0,2.1-2.1V2.658a2.1,2.1,0,0,0-2.1-2.1Z"/></svg>,
    helpVideo: '448967324',
    settings: {
      sections: [
        {
          headline: 'Bild',
          fields: [
            {
              type: 'image',
              name: 'image',
              label: 'Bild'
            }
          ]
        },
        {
          headline: 'Hotspots',
          fields: [
            {
              type: 'repeater',
              name: 'hotspots',
              label: 'Hotspots',
              addItemLabel: 'Hotspot hinzufügen',
              fields: [
                {
                  type: 'coordinates',
                  name: 'position',
                  label: 'Position',
                  defaultValue: {
                    x: '50',
                    y: '50'
                  }
                },
                {
                  type: 'textarea',
                  name: 'text',
                  label: 'Inhalt'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'slider',
    itemType: 'element',
    category: 'content',
    title: 'Slider',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22.511" viewBox="0 0 24 22.511"><path d="M25.152,21.333V1.032A1.046,1.046,0,0,0,24.12,0H10.99A1.05,1.05,0,0,0,9.94,1.037V21.478a1.046,1.046,0,0,0,1.037,1.032h13.13a1.173,1.173,0,0,0,1.046-1.177ZM10.51,1.032A.453.453,0,0,1,10.963.58h13.13a.453.453,0,0,1,.453.453v20.3c0,.244-.195.611-.453.611H10.963a.453.453,0,0,1-.453-.453Z" transform="translate(-5.447)"/><rect width="0.543" height="17.376" transform="translate(4.739 0.613) rotate(-54.93)"/><rect width="17.376" height="0.543" transform="translate(4.739 10.153) rotate(-35.06)"/><path d="M47.268,25.491a.285.285,0,0,1-.195-.077.276.276,0,0,1,0-.385l2.1-2.092-2.1-2.069a.272.272,0,0,1,.385-.385l2.151,2.123a.5.5,0,0,1,0,.643l-2.16,2.164A.263.263,0,0,1,47.268,25.491Z" transform="translate(-25.725 -11.166)"/><path d="M2.481,25.515a.267.267,0,0,1-.208-.077L.136,23.315a.493.493,0,0,1,0-.643l2.137-2.146a.276.276,0,0,1,.385,0,.272.272,0,0,1,0,.385L.571,22.984l2.1,2.069a.272.272,0,0,1,0,.385.276.276,0,0,1-.19.077Z" transform="translate(-0.017 -11.19)"/><path d="M25.466,36.5c.1,0,.186-.122.186-.272s-.081-.272-.186-.272H15.37c-.109,0-.19.122-.19.272s.081.272.19.272Z" transform="translate(-8.315 -19.679)"/><path d="M25.466,30.169c.1,0,.186-.118.186-.267s-.081-.272-.186-.272H15.37c-.109,0-.19.122-.19.272s.081.267.19.267Z" transform="translate(-8.315 -16.215)"/><path d="M24.9,23.169a.263.263,0,0,0,.263-.267.267.267,0,0,0-.263-.272H10.413a.267.267,0,0,0-.263.272.263.263,0,0,0,.263.267Z" transform="translate(-5.562 -12.384)"/><path d="M25.466,42.839c.1,0,.186-.122.186-.272s-.081-.267-.186-.267H15.37c-.109,0-.19.122-.19.267s.081.272.19.272Z" transform="translate(-8.315 -23.149)"/></svg>,
    helpVideo: '448967774',
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'repeater',
              name: 'slides',
              label: 'Slides',
              addItemLabel: 'Slide hinzufügen',
              fields: [
                {
                  type: 'image',
                  name: 'image',
                  label: 'Bild'
                },
                {
                  type: 'textarea',
                  name: 'headline',
                  label: 'Titel'
                },
                {
                  type: 'textarea',
                  name: 'text',
                  label: 'Text'
                }
              ],
              defaultValue: [
                {}
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'lenticular_slider',
    itemType: 'element',
    category: 'content',
    title: 'Lentikular Slider',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.643" viewBox="0 0 24 23.643"><path d="M23.978,22.842V11.07C24.073,10,23.5,9.995,22.424,10H1.084C.965,10-.1,10-.006,11.075V22.994a1.1,1.1,0,0,0,1.09,1.081h21.8a1.227,1.227,0,0,0,1.095-1.232Zm-.592,0c0,.256-.209.635-.474.635H1.084A.474.474,0,0,1,.61,23V11.07a.474.474,0,0,1,.474-.474h21.8a.474.474,0,0,1,.474.474Z" transform="translate(0.011 -5.26)"/><path d="M24.72,29.74V39a.284.284,0,0,0,.284.284.28.28,0,0,0,.28-.284V29.749Z" transform="translate(-13 -15.646)"/><path d="M24.72,9.3V.284A.284.284,0,0,1,25,0a.28.28,0,0,1,.28.284v9Z" transform="translate(-13 0)"/><path d="M22.242,24.325a2.772,2.772,0,1,1,2.772-2.772A2.772,2.772,0,0,1,22.242,24.325Zm0-4.976a.914.914,0,1,1,0,.009Z" transform="translate(-10.238 -9.88)"/><path d="M23.953,24.463a.289.289,0,0,1-.2-.085.284.284,0,0,1,0-.4l1.066-1.052L23.749,21.88a.289.289,0,0,1,0-.4.284.284,0,0,1,.4,0l1.175,1.152a.445.445,0,0,1,0,.573l-1.175,1.18a.261.261,0,0,1-.2.081Z" transform="translate(-12.446 -11.255)"/><path d="M6.1,10.744V23.866a.284.284,0,1,0,.564,0V10.744a.284.284,0,1,0-.564,0Z" transform="translate(-3.201 -5.483)"/><path d="M2.45,10.784V23.907a.284.284,0,0,0,.569,0V10.784a.284.284,0,1,0-.569,0Z" transform="translate(-1.284 -5.524)"/><path d="M11.1,10.744V23.866a.284.284,0,1,0,.564,0V10.744a.284.284,0,1,0-.564,0Z" transform="translate(-5.832 -5.483)"/><path d="M17.1,10.744V23.866a.284.284,0,1,0,.564,0V10.744a.284.284,0,1,0-.564,0Z" transform="translate(-8.988 -5.483)"/><path d="M35.1,10.744V23.866a.284.284,0,1,0,.564,0V10.744a.284.284,0,1,0-.564,0Z" transform="translate(-18.458 -5.483)"/></svg>,
    helpVideo: '448967466',
    settings: {
      sections: [
        {
          headline: 'Vorher-Bild',
          fields: [
            {
              type: 'image',
              name: 'image_left',
              label: 'Vorher-Bild'
            }
          ]
        },
        {
          headline: 'Nacher-Bild',
          fields: [
            {
              type: 'image',
              name: 'image_right',
              label: 'Nacher-Bild'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'accordion',
    itemType: 'element',
    category: 'content',
    title: 'Akkordeon',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22.829" viewBox="0 0 24 22.829"><rect width="17.486" height="0.617" transform="translate(0 1.278)" /><rect width="23.763" height="0.617" transform="translate(0 4.642)" /><rect width="23.763" height="0.617" transform="translate(0 6.939)" /><path d="M19.475,2.937,19.039,2.5l2.5-2.5L24,2.5l-.44.432L21.537.876Z" /><rect width="17.486" height="0.617" transform="translate(0 13.104)" /><path d="M21.5,14.983l-2.459-2.5.44-.432,2.023,2.06,2.061-2.062.436.436Z" /><rect width="23.763" height="0.617" transform="translate(0 9.181)" /><rect width="17.486" height="0.617" transform="translate(0 17.027)" /><path d="M21.5,18.906l-2.459-2.5.44-.432,2.023,2.06,2.061-2.062L24,16.4Z" /><rect width="17.486" height="0.617" transform="translate(0 20.95)" /><path d="M21.5,22.829l-2.459-2.5.44-.432,2.023,2.06,2.061-2.062.436.436Z" /></svg>,
    helpVideo: '448967073',
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'repeater',
              name: 'sections',
              label: 'Sektionen',
              addItemLabel: 'Sektion hinzufügen',
              fields: [
                {
                  type: 'textarea',
                  name: 'headline',
                  label: 'Titel'
                },
                {
                  type: 'wysiwyg',
                  name: 'text',
                  label: 'Text'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'button',
    itemType: 'element',
    category: 'content',
    title: 'Button',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Gruppe_maskieren_26" data-name="Gruppe maskieren 26" transform="translate(-9467 11248)">
        <g id="Ebene_2" data-name="Ebene 2" transform="translate(9467 -11247.887)">
          <g id="Ebene_1" data-name="Ebene 1">
            <path id="Pfad_1011" data-name="Pfad 1011" d="M8.277,3.522a1.746,1.746,0,0,0-.438.327H7.814a1.751,1.751,0,0,0-.257.352H5.172a.352.352,0,0,1,0-.7Z" fill="#f644eb"/>
            <path id="Pfad_1012" data-name="Pfad 1012" d="M19.281,3.874a.352.352,0,0,1-.352.352H10.566a1.65,1.65,0,0,0-.242-.347,1.756,1.756,0,0,0-.473-.357h9.057a.352.352,0,0,1,.372.352Z" fill="#f644eb"/>
            <path id="Pfad_1013" data-name="Pfad 1013" d="M20.126,0H4.025a3.874,3.874,0,1,0,0,7.748H6.984v-.7H4.025a3.17,3.17,0,0,1,0-6.34h16.1a3.17,3.17,0,0,1,0,6.34H10.984v.7h9.142a3.874,3.874,0,0,0,0-7.748Z" fill="#f644eb"/>
            <path id="Pfad_1014" data-name="Pfad 1014" d="M3.909,23.723l-3.3-3.829a2.47,2.47,0,0,1,2.138-4.045,2.516,2.516,0,0,1,1.509.714l1.67,1.67a.433.433,0,0,0,.478.1.443.443,0,0,0,.282-.4l-.015-12.9A2.35,2.35,0,0,1,7.326,3.4v-.03a2.365,2.365,0,0,1,4.1,1.66v8.05h-.634V5.031A1.731,1.731,0,0,0,9.082,3.306a1.756,1.756,0,0,0-1.273.518v.025a1.726,1.726,0,0,0-.5,1.182l.03,12.891a1.072,1.072,0,0,1-1.836.745l-1.67-1.655A1.847,1.847,0,0,0,1.1,19.487l3.291,3.824Z" fill="#f644eb"/>
            <path id="Pfad_1015" data-name="Pfad 1015" d="M11.286,4.226a2.284,2.284,0,0,0-.4-.7h-.045a2.189,2.189,0,0,1,.4.7,2.189,2.189,0,0,1,.141.805V7.044h.04V5.031A2.3,2.3,0,0,0,11.286,4.226Zm.035,0a2.244,2.244,0,0,0-.387-.7,1.062,1.062,0,0,0-.1-.116,2.42,2.42,0,0,0-1.746-.79,2.385,2.385,0,0,0-1.766.745L7.3,3.386l-.116.136a2.174,2.174,0,0,0-.4.7,2.385,2.385,0,0,0-.146.805v12.9a.406.406,0,0,1-.694.277l-1.64-1.67A2.519,2.519,0,0,0,.584,19.919l3.3,3.824v.03l.533-.463L1.122,19.462a1.813,1.813,0,0,1,1.59-2.969,1.811,1.811,0,0,1,1.1.5l1.67,1.67a1.117,1.117,0,0,0,1.9-.775l-.03-12.86a1.635,1.635,0,0,1,.2-.805A1.751,1.751,0,0,1,7.8,3.874h.025a1.721,1.721,0,0,1,1.238-.5h0a1.68,1.68,0,0,1,.785.151,1.756,1.756,0,0,1,.463.357,1.711,1.711,0,0,1,.438,1.152v8.086h.7V5.031A2.3,2.3,0,0,0,11.321,4.226Zm.06,8.815h-.553V5.031a1.691,1.691,0,0,0-.191-.785,1.721,1.721,0,0,0-.267-.4A1.751,1.751,0,0,0,10,3.522a1.731,1.731,0,0,0-.921-.272h0a1.786,1.786,0,0,0-.956.272,1.65,1.65,0,0,0-.342.277H7.758a1.726,1.726,0,0,0-.287.4,1.761,1.761,0,0,0-.2.815l.035,12.891a1.036,1.036,0,0,1-1.771.745l-1.675-1.67a1.872,1.872,0,0,0-1.137-.538,1.872,1.872,0,0,0-1.655,3.064l3.265,3.8-.423.342-3.27-3.8a2.46,2.46,0,0,1-.564-1.56,2.43,2.43,0,0,1,2.44-2.415h.242a2.465,2.465,0,0,1,1.509.7l1.67,1.67a.463.463,0,0,0,.5.106.473.473,0,0,0,.3-.438L6.722,7.748V5.031a2.239,2.239,0,0,1,.151-.82,2.143,2.143,0,0,1,.413-.689l.07-.081h.025a2.269,2.269,0,0,1,1.645-.725h.06a2.345,2.345,0,0,1,1.7.765l.055.065a2.189,2.189,0,0,1,.4.7,2.189,2.189,0,0,1,.141.78Z" fill="#f644eb"/>
            <path id="Pfad_1016" data-name="Pfad 1016" d="M15.512,15.477h-.629V12.458a1.721,1.721,0,0,0-1.706-1.726,1.7,1.7,0,0,0-1.273.533h-.025a1.736,1.736,0,0,0-.473,1.2l.03,2.128H10.8l-.03-2.133a2.37,2.37,0,0,1,.649-1.635l.025-.025a2.355,2.355,0,0,1,4.065,1.625Z" fill="#f644eb"/>
            <path id="Pfad_1017" data-name="Pfad 1017" d="M15.482,11.9a.151.151,0,0,0,0-.05v-.045a2.355,2.355,0,0,0-.5-.946,2.4,2.4,0,0,0-1.8-.8h0a2.39,2.39,0,0,0-1.706.709.231.231,0,0,0-.035.035l-.025.03h0a2.37,2.37,0,0,0-.553.961,1.806,1.806,0,0,0-.04.176,1.358,1.358,0,0,0-.035.206,1.917,1.917,0,0,0,0,.3l.035,2.174h.709V12.483a1.308,1.308,0,0,1,0-.2,1.635,1.635,0,0,1,.453-.966v-.03a1.675,1.675,0,0,1,1.213-.5h.035a1.66,1.66,0,0,1,1.228.553,1.691,1.691,0,0,1,.438,1.137v3.044h.709V12.473a2.345,2.345,0,0,0-.126-.569Zm0,3.522h-.564V12.458a1.766,1.766,0,0,0-1.741-1.766h-.04a1.726,1.726,0,0,0-1.258.548l-.025.025a1.761,1.761,0,0,0-.4.664.845.845,0,0,0-.035.121,1.122,1.122,0,0,0-.04.226,1.509,1.509,0,0,0,0,.211v2.093h-.553V12.508a2.481,2.481,0,0,1,0-.277,2.254,2.254,0,0,1,.553-1.258l.04-.045.025-.03h0a2.35,2.35,0,0,1,1.691-.725h0a2.325,2.325,0,0,1,1.691.765,2.269,2.269,0,0,1,.5.966.151.151,0,0,1,0,.05.081.081,0,0,1,0,.045,2.325,2.325,0,0,1,.055.5Z" fill="#f644eb"/>
            <path id="Pfad_1018" data-name="Pfad 1018" d="M19.592,16.428h-.634V13.409a1.721,1.721,0,0,0-1.706-1.726,1.691,1.691,0,0,0-1.268.538l-.025.025a1.721,1.721,0,0,0-.478,1.192l.035,2.158h-.634l-.03-2.138a2.35,2.35,0,0,1,.649-1.635h.025a2.356,2.356,0,0,1,4.065,1.625Z" fill="#f644eb"/>
            <path id="Pfad_1019" data-name="Pfad 1019" d="M19.562,12.85a.146.146,0,0,0,0-.045.146.146,0,0,1,0-.045,2.41,2.41,0,0,0-2.279-1.736h-.03a2.41,2.41,0,0,0-1.736.745l-.025.025h0l-.03.04-.03.03a2.44,2.44,0,0,0-.5.865,1.439,1.439,0,0,0-.035.141,1.006,1.006,0,0,0-.04.206,2.2,2.2,0,0,0-.03.362l.03,1.862v.312h.7v-.1l-.03-2.068a1.7,1.7,0,0,1,.463-1.167l.025-.025a1.655,1.655,0,0,1,1.208-.5h.035a1.66,1.66,0,0,1,1.233.553,1.691,1.691,0,0,1,.438,1.132v3.019h.694V13.434a2.41,2.41,0,0,0-.06-.584Zm0,3.522H19V13.4a1.766,1.766,0,0,0-1.741-1.761h-.04a1.736,1.736,0,0,0-1.263.548H15.93a1.756,1.756,0,0,0-.377.619,1.132,1.132,0,0,0-.04.121.205.205,0,0,1-.035.141,1.867,1.867,0,0,0-.03.337l.03,2.013v.106h-.553v-.3l-.03-1.8a2.214,2.214,0,0,1,.03-.367,2.264,2.264,0,0,1,.5-1.112l.025-.035a.232.232,0,0,1,.035-.035.242.242,0,0,1,.045-.055l.025-.03a2.34,2.34,0,0,1,1.681-.719h.03a2.345,2.345,0,0,1,1.691.76,2.289,2.289,0,0,1,.5.971.086.086,0,0,1,0,.05.1.1,0,0,1,0,.04,2.325,2.325,0,0,1,.055.5Z" fill="#f644eb"/>
            <path id="Pfad_1020" data-name="Pfad 1020" d="M23.673,23.517h-.634V14.37a1.731,1.731,0,0,0-2.979-1.192v.03a1.721,1.721,0,0,0-.478,1.192l.04,2.128h-.634l-.03-2.133a2.325,2.325,0,0,1,.649-1.635v-.025a2.361,2.361,0,0,1,4.07,1.625Z" fill="#f644eb"/>
            <path id="Pfad_1021" data-name="Pfad 1021" d="M23.089,12.76a2.39,2.39,0,0,0-1.746-.785h-.035a2.39,2.39,0,0,0-1.731.75h0a.116.116,0,0,0-.035.035l-.03.035a2.289,2.289,0,0,0-.5.865,1.509,1.509,0,0,0-.04.161.76.76,0,0,0-.035.186,2.153,2.153,0,0,0-.03.362l.03,2.058V16.6h.709V16.5l-.02-2.1a1.866,1.866,0,0,1,0-.312,1.675,1.675,0,0,1,.433-.83v-.025a1.65,1.65,0,0,1,1.278-.553A1.686,1.686,0,0,1,23,14.37v9.182h.7V14.37a2.38,2.38,0,0,0-.619-1.61Zm.558,10.717h-.553V14.37a1.786,1.786,0,0,0-.453-1.187,1.741,1.741,0,0,0-1.288-.579h-.045a1.751,1.751,0,0,0-1.253.548v.025a1.761,1.761,0,0,0-.433.614.78.78,0,0,0-.04.116.205.205,0,0,1-.035.141,2.013,2.013,0,0,0-.03.352l.03,1.987v.106h-.558v-.116l-.03-1.982a2.274,2.274,0,0,1,.03-.372,2.314,2.314,0,0,1,.5-1.112.091.091,0,0,1,.025-.035.116.116,0,0,1,.035-.035.438.438,0,0,1,.045-.055l.025-.025a2.325,2.325,0,0,1,1.686-.684h.035a2.314,2.314,0,0,1,2.3,2.294Z" fill="#f644eb"/>
          </g>
        </g>
      </g>
    </svg>,
    settings: {
      sections: [
        {
          headline: 'Button-URL',
          fields: [
            {
              type: 'text',
              name: 'url',
              label: 'URL Link einfügen'
            }
          ]
        },
        {
          headline: 'Beschriftung',
          fields: [
            {
              type: 'text',
              name: 'description',
              label: 'Beschriftung'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'drag_and_drop',
    itemType: 'element',
    category: 'quiz',
    title: 'Drag & Drop',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.399" viewBox="0 0 24 23.399"><path d="M25.216,14.9H13.573V.572H27.9V13.25l.578.2V.465A.466.466,0,0,0,27.992,0h-14.5A.466.466,0,0,0,13,.465V15a.466.466,0,0,0,.489.466H25.356Z" transform="translate(-6.945 0.001)"/><path d="M13.607,20.1l-.447-.335,4.238-5.58,1.849,1.849,3.735-5.607,5.472,6.134-.415.373-4.993-5.593-3.717,5.57-1.877-1.877Z" transform="translate(-7.03 -5.572)"/><path d="M19.642,8.785a2.142,2.142,0,1,1,2.142-2.142,2.142,2.142,0,0,1-2.142,2.142Zm0-3.726a1.584,1.584,0,1,0,1.584,1.584,1.584,1.584,0,0,0-1.584-1.584Z" transform="translate(-9.349 -2.404)"/><path d="M38.511,32.547,36.42,25.51,43.457,27.6l-1.784,1.784,1.649,1.644-1.4,1.4L40.29,30.768Zm1.779-2.571,1.649,1.644.591-.591-1.649-1.644,1.509-1.514-5.123-1.532L38.8,31.49Z" transform="translate(-19.457 -13.628)"/><rect width="2.138" height="0.48" transform="translate(3.307 7.965)"/><path d="M9.231,17.573H7V17H9.231Zm-2.138-.107H9.138v-.373H7.093Z" transform="translate(-3.739 -9.082)"/><rect width="0.48" height="2.138" transform="translate(0.047 11.225)"/><path d="M.568,26.231H0V24H.568ZM.1,26.138H.466V24.093H.093Z" transform="translate(0.001 -12.822)"/><rect width="0.48" height="2.138" transform="translate(0.047 14.485)"/><path d="M.568,33.231H0V31H.568ZM.1,33.138H.466V31.093H.093Z" transform="translate(0.001 -16.562)"/><path d="M1.9,48.249H.5a.466.466,0,0,1-.438-.466V46.6H.526v1.164H1.9Z" transform="translate(-0.031 -24.896)"/><path d="M1.914,48.242H.465A.466.466,0,0,1,0,47.753V46.5H.568v1.164H1.914ZM.092,46.593v1.16a.4.4,0,0,0,.373.377H1.82v-.373H.465V46.593Z" transform="translate(0.001 -24.843)"/><rect width="0.48" height="2.138" transform="translate(0.047 17.955)"/><path d="M.568,40.681H0V38.45H.568Zm-.475-.112H.466V38.543H.093Z" transform="translate(0.001 -20.542)"/><rect width="2.138" height="0.48" transform="translate(3.307 22.873)"/><path d="M9.231,49.578H7V49H9.231Zm-2.138-.112H9.138v-.387H7.093Z" transform="translate(-3.739 -26.178)"/><path d="M.1,18.9V17.5a.466.466,0,0,1,.466-.438H1.749v.466H.584V18.9Z" transform="translate(-0.053 -9.114)"/><path d="M.578,18.914H0V17.465A.466.466,0,0,1,.489,17H1.742v.573H.578ZM.112,18.82H.466V17.465H1.63v-.373H.489a.4.4,0,0,0-.4.373Z" transform="translate(0.001 -9.081)"/><rect width="2.138" height="0.48" transform="translate(6.586 22.873)"/><path d="M16.25,49.578H14V49h2.231Zm-2.138-.112h2.045v-.387H14.112Z" transform="translate(-7.479 -26.178)"/><path d="M31.289,46.23v1.4a.466.466,0,0,1-.466.438H29.64V47.6H30.8V46.23Z" transform="translate(-15.835 -24.698)"/><path d="M30.793,48.044H29.54v-.578h1.146V46.13h.578v1.43a.466.466,0,0,1-.47.484Zm-1.16-.112h1.16a.4.4,0,0,0,.4-.391V46.223H30.8v1.341H29.633Z" transform="translate(-15.782 -24.645)"/><rect width="2.138" height="0.48" transform="translate(10.056 22.873)"/><path d="M23.721,49.578H21.49V49h2.231Zm-2.138-.112h2.045v-.387H21.583Z" transform="translate(-11.481 -26.178)"/><rect width="0.48" height="2.138" transform="translate(14.974 17.955)"/><path d="M32.623,40.681H32.05V38.45h.573Zm-.466-.093h.387V38.543h-.387Z" transform="translate(-17.123 -20.542)"/><rect width="0.48" height="1.206" transform="translate(14.974 15.16)"/><path d="M32.623,33.749H32.05v-1.3h.573Zm-.466-.093h.387V32.543h-.387Z" transform="translate(-17.123 -17.336)"/></svg>,
    helpVideo: '448967233',
    settings: {
      sections: [
        {
          headline: 'Titel',
          fields: [
            {
              type: 'switch',
              name: 'box_show',
              label: 'Anzeigen',
              defaultValue: true
            },
            {
              type: 'text',
              name: 'box_headline',
              label: 'Titel'
            },
            {
              type: 'textarea',
              name: 'box_text',
              label: 'Text'
            }
          ]
        },
        {
          headline: 'Lernzielkontrolle',
          description: 'Prüfungsfragen sind für das Abschließen des WBTs relevant. Bei 66% richtig beantworteten Prüfungsfragen gilt das WBT als bestanden.',
          fields: [
            {
              type: 'switch',
              name: 'required_question',
              label: 'Prüfungsfrage'
            }
          ]
        },
        {
          headline: 'Felder',
          fields: [
            {
              type: 'repeater',
              name: 'fields',
              label: 'Felder',
              simplified: true,
              addItemLabel: 'Feld hinzufügen',
              maxItems: 4,
              fields: [
                {
                  type: 'text',
                  name: 'field',
                  label: 'Feld'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                }
              ]
            }
          ]
        },
        {
          headline: 'Karten',
          fields: [
            {
              type: 'repeater',
              name: 'cards',
              label: 'Karten',
              addItemLabel: 'Karte hinzufügen',
              fields: [
                {
                  type: 'text',
                  name: 'text',
                  label: 'Text'
                },
                {
                  type: 'select',
                  name: 'field',
                  label: 'Feld',
                  options: 'fields.field'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'multiple_choice',
    itemType: 'element',
    category: 'quiz',
    title: 'Multiple Choice',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17.511" viewBox="0 0 24 17.511"><path d="M13.018,32.23a.283.283,0,0,1-.288-.283.288.288,0,0,1,.288-.288H30.3a.288.288,0,0,1,.288.288.283.283,0,0,1-.288.283Z" transform="translate(-6.628 -16.484)"/><path d="M3.921,31.74H.532A.532.532,0,0,1,0,31.213V27.857a.532.532,0,0,1,.532-.527H3.921a.532.532,0,0,1,.532.527v3.355A.532.532,0,0,1,3.921,31.74ZM.566,31.165H3.873v-3.26H.58Z" transform="translate(0 -14.229)"/><path d="M13.018,18.57a.288.288,0,0,1-.288-.288A.283.283,0,0,1,13.018,18H30.3a.283.283,0,0,1,.288.283.288.288,0,0,1-.288.288Z" transform="translate(-6.628 -9.372)"/><path d="M3.921,18.08H.532A.532.532,0,0,1,0,17.553V14.2a.532.532,0,0,1,.532-.527H3.921a.532.532,0,0,1,.532.527v3.355A.532.532,0,0,1,3.921,18.08ZM.566,17.5H3.873v-3.26H.58Z" transform="translate(0 -7.117)"/><rect width="4.933" height="0.575" transform="matrix(0.711, -0.703, 0.703, 0.711, 0.272, 10.286)"/><rect width="0.575" height="4.933" transform="translate(0.274 7.226) rotate(-45.28)"/><path d="M12.977,4.9a.288.288,0,1,1,0-.57H30.263a.288.288,0,1,1,0,.57Z" transform="translate(-6.588 -2.252)"/><path d="M3.921,4.41H.532A.532.532,0,0,1,0,3.883V.527A.532.532,0,0,1,.532,0H3.921a.532.532,0,0,1,.532.527V3.883A.532.532,0,0,1,3.921,4.41ZM.58,3.835H3.873V.575H.58Z" transform="translate(0)"/></svg>,
    helpVideo: '448967487',
    settings: {
      sections: [
        {
          headline: 'Titel',
          fields: [
            {
              type: 'switch',
              name: 'box_show',
              label: 'Anzeigen',
              defaultValue: true
            },
            {
              type: 'text',
              name: 'box_headline',
              label: 'Titel'
            },
            {
              type: 'textarea',
              name: 'box_text',
              label: 'Text'
            }
          ]
        },
        {
          headline: 'Lernzielkontrolle',
          description: 'Prüfungsfragen sind für das Abschließen des WBTs relevant. Bei 66% richtig beantworteten Prüfungsfragen gilt das WBT als bestanden.',
          fields: [
            {
              type: 'switch',
              name: 'required_question',
              label: 'Prüfungsfrage'
            }
          ]
        },
        {
          headline: 'Antworten',
          fields: [
            {
              type: 'repeater',
              name: 'answers',
              label: 'Antworten',
              addItemLabel: 'Antworten hinzufügen',
              fields: [
                {
                  type: 'text',
                  name: 'text',
                  label: 'Text'
                },
                {
                  type: 'select',
                  name: 'field',
                  label: 'Feld',
                  options: [
                    {
                      valie: 'right',
                      name: 'Richtig'
                    },
                    {
                      valie: 'right',
                      name: 'Falsch'
                    },
                    {
                      valie: 'partly-right',
                      name: 'Teilweise richtig'
                    }
                  ]
                },
                {
                  type: 'overlay',
                  name: 'overlay',
                  label: 'Overlay'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                },
                {
                  settings: {}
                },
                {
                  settings: {}
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'free_text_field',
    itemType: 'element',
    category: 'quiz',
    title: 'Freitextfeld',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><rect width="0.497" height="2.194" transform="translate(0.048 18.32)"/><path d="M.593,40.505H0V38.22H.593Zm-.478-.1H.478V38.316H.1Z" transform="translate(0 -19.947)"/><rect width="0.497" height="2.194" transform="translate(0.048 14.634)"/><path d="M.593,32.8H0V30.51H.593Zm-.478-.1H.478v-2.1H.1Z" transform="translate(0 -15.924)"/><rect width="0.497" height="2.194" transform="translate(0.048 10.948)"/><path d="M.593,25.09H0V22.8H.593Zm-.478-.1H.478V22.9H.1Z" transform="translate(0 -11.9)"/><rect width="0.497" height="2.194" transform="translate(0.048 7.262)"/><path d="M.593,17.375H0V15.09H.593Zm-.478-.1H.478V15.186H.1Z" transform="translate(0 -7.876)"/><rect width="0.497" height="2.194" transform="translate(0.048 3.571)"/><path d="M.593,9.66H0V7.37H.593ZM.1,9.584H.478V7.466H.1Z" transform="translate(0 -3.846)"/><path d="M.1,1.944V.509A.478.478,0,0,1,.578.06H2.3V.538H.607V1.944Z" transform="translate(-0.052 -0.031)"/><path d="M.6,1.965H0V.478A.507.507,0,0,1,.512,0H2.3V.583H.6ZM.1,1.869H.507V.478H2.2V.1H.512A.411.411,0,0,0,.1.478Z" transform="translate(0 0)"/><rect width="2.194" height="0.497" transform="translate(3.485 0.048)"/><path d="M9.49.593H7.19V0h2.3ZM7.286.478h2.1V.1h-2.1Z" transform="translate(-3.753 0)"/><rect width="2.194" height="0.497" transform="translate(7.171 0.048)"/><path d="M17.19.593H14.9V0h2.29ZM15,.478h2.1V.1H15Z" transform="translate(-7.776 0)"/><rect width="2.194" height="0.497" transform="translate(10.857 0.048)"/><path d="M24.9.593H22.61V0H24.9ZM22.706.478h2.1V.1h-2.1Z" transform="translate(-11.8 0)"/><rect width="2.194" height="0.497" transform="translate(14.548 0.048)"/><path d="M32.615.593H30.33V0h2.285ZM30.426.478H32.52V.1H30.426Z" transform="translate(-15.83 0)"/><rect width="2.194" height="0.497" transform="translate(18.234 0.048)"/><path d="M40.309.593H38V0h2.29ZM38.115.478h2.1V.1h-2.1Z" transform="translate(-19.833 0)"/><path d="M46.19.1h1.434a.478.478,0,0,1,.449.478V1.826H47.6V.607H46.19Z" transform="translate(-24.107 -0.052)"/><path d="M48.055,1.822h-.574V.6H46.09V0h1.468a.507.507,0,0,1,.478.512Zm-.478-.1h.382V.512a.411.411,0,0,0-.4-.416H46.186V.507h1.377Z" transform="translate(-24.055 0)"/><rect width="0.497" height="2.194" transform="translate(23.455 3.485)"/><path d="M49.574,9.49H49V7.19h.574Zm-.5-.091h.406V7.286h-.406Z" transform="translate(-25.574 -3.753)"/><rect width="0.497" height="2.194" transform="translate(23.455 7.171)"/><path d="M49.574,17.19H49V14.9h.574Zm-.5-.1h.406V15h-.406Z" transform="translate(-25.574 -7.776)"/><rect width="0.497" height="2.194" transform="translate(23.455 10.857)"/><path d="M49.574,24.9H49V22.61h.574Zm-.5-.1h.406v-2.1h-.406Z" transform="translate(-25.574 -11.8)"/><rect width="0.497" height="2.194" transform="translate(23.455 14.548)"/><path d="M49.574,32.615H49V30.33h.574Zm-.5-.1h.406V30.426h-.406Z" transform="translate(-25.574 -15.83)"/><rect width="0.497" height="2.194" transform="translate(23.455 18.234)"/><path d="M49.574,40.309H49V38h.574Zm-.5-.1h.406v-2.1h-.406Z" transform="translate(-25.574 -19.833)"/><path d="M48.216,46.19v1.434a.478.478,0,0,1-.478.449H46.49V47.6h1.2V46.19Z" transform="translate(-24.264 -24.107)"/><path d="M47.7,48.055H46.39v-.574h1.219V46.09h.6v1.468A.507.507,0,0,1,47.7,48.055Zm-1.214-.1H47.7a.411.411,0,0,0,.416-.4V46.186H47.7v1.377H46.486Z" transform="translate(-24.212 -24.055)"/><rect width="2.194" height="0.497" transform="translate(18.32 23.45)"/><path d="M40.505,49.574H38.22V49h2.285Zm-2.19-.1h2.1v-.406h-2.1Z" transform="translate(-19.947 -25.574)"/><rect width="2.194" height="0.497" transform="translate(14.634 23.45)"/><path d="M32.8,49.574H30.51V49H32.8Zm-2.194-.1h2.1v-.406h-2.1Z" transform="translate(-15.924 -25.574)"/><rect width="2.194" height="0.497" transform="translate(10.948 23.45)"/><path d="M25.09,49.574H22.8V49h2.29Zm-2.194-.1h2.1v-.406H22.9Z" transform="translate(-11.9 -25.574)"/><rect width="2.194" height="0.497" transform="translate(7.262 23.45)"/><path d="M17.375,49.574H15.09V49h2.285Zm-2.19-.1H17.28v-.406H15.186Z" transform="translate(-7.876 -25.574)"/><rect width="2.194" height="0.497" transform="translate(3.571 23.45)"/><path d="M9.66,49.574H7.37V49H9.66Zm-2.194-.1H9.584v-.406H7.466Z" transform="translate(-3.846 -25.574)"/><path d="M1.944,48.216H.509a.478.478,0,0,1-.449-.478V46.49H.538v1.2H1.944Z" transform="translate(-0.031 -24.264)"/><path d="M1.965,48.212H.478A.507.507,0,0,1,0,47.7V46.39H.583v1.219H1.965ZM.1,46.486V47.7a.411.411,0,0,0,.382.416H1.869V47.7H.478V46.486Z" transform="translate(0 -24.212)"/><path d="M26,25.1v-.574c2.051,0,2.782-.578,2.782-2.223V10.587c0-1.64-.731-2.218-2.782-2.218V7.79c1.74,0,3.347.339,3.347,2.8V22.3C29.347,24.757,27.74,25.1,26,25.1Z" transform="translate(-13.57 -4.066)"/><path d="M35.177,25.1c-1.74,0-3.347-.339-3.347-2.8V10.587c0-2.457,1.611-2.8,3.347-2.8v.578c-2.051,0-2.787.578-2.787,2.218V22.3c0,1.645.727,2.223,2.778,2.223Z" transform="translate(-16.612 -4.066)"/><rect width="2.194" height="0.497" transform="translate(14.4 16.59)"/><path d="M32.3,35.193H30V34.6h2.29Zm-2.194-.1h2.1v-.4h-2.1Z" transform="translate(-15.657 -18.058)"/></svg>,
    helpVideo: '448967259',
    settings: {
      sections: [
        {
          headline: 'Titel',
          fields: [
            {
              type: 'switch',
              name: 'box_show',
              label: 'Anzeigen',
              defaultValue: true
            },
            {
              type: 'text',
              name: 'box_headline',
              label: 'Titel'
            },
            {
              type: 'textarea',
              name: 'box_text',
              label: 'Text'
            },
            {
              type: 'image',
              name: 'box_image',
              label: 'Bild'
            },
            {
              type: 'audio',
              name: 'box_audio',
              label: 'Audio'
            }
          ]
        },
        {
          headline: 'Freitextfeld',
          fields: [
            {
              type: 'text',
              name: 'placeholder',
              label: 'Platzhalter'
            },
            {
              type: 'text',
              name: 'limit',
              label: 'Maximiale Zeichenbegrenzung'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'pairs',
    itemType: 'element',
    category: 'quiz',
    title: 'Paar Quiz',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="23.904" height="24" viewBox="0 0 23.904 24"><path d="M8.792,4.4H.535A.531.531,0,0,1,0,3.872V.526A.531.531,0,0,1,.535,0H8.792a.531.531,0,0,1,.535.526V3.872A.531.531,0,0,1,8.792,4.4ZM.583,3.825H8.744V.574H.583Z" transform="translate(0 0)"/><path d="M39.272,4.4H31.015a.531.531,0,0,1-.535-.526V.526A.531.531,0,0,1,31.015,0h8.257a.531.531,0,0,1,.54.526V3.872a.531.531,0,0,1-.54.526Zm-8.209-.574h8.161V.574H31.063Z" transform="translate(-15.908 0)"/><path d="M8.792,18.068H.535A.531.531,0,0,1,0,17.542V14.2a.531.531,0,0,1,.535-.526H8.792a.531.531,0,0,1,.535.526v3.347A.531.531,0,0,1,8.792,18.068ZM.583,17.495H8.744V14.244H.583Z" transform="translate(0 -7.134)"/><path d="M39.272,18.068H31.015a.531.531,0,0,1-.535-.526V14.2a.531.531,0,0,1,.535-.526h8.257a.531.531,0,0,1,.54.526v3.347a.531.531,0,0,1-.54.526Zm-8.209-.574h8.161V14.244H31.063Z" transform="translate(-15.908 -7.134)"/><path d="M8.792,31.728H.535A.531.531,0,0,1,0,31.2V27.856a.531.531,0,0,1,.535-.526H8.792a.531.531,0,0,1,.535.526V31.2A.531.531,0,0,1,8.792,31.728ZM.583,31.155H8.744V27.9H.583Z" transform="translate(0 -14.264)"/><path d="M39.272,31.728H31.015a.531.531,0,0,1-.535-.526V27.856a.531.531,0,0,1,.535-.526h8.257a.531.531,0,0,1,.54.526V31.2a.531.531,0,0,1-.54.526Zm-8.209-.574h8.161V27.9H31.063Z" transform="translate(-15.908 -14.264)"/><path d="M8.792,45.4H.535A.531.531,0,0,1,0,44.872V41.526A.531.531,0,0,1,.535,41H8.792a.531.531,0,0,1,.535.526v3.347A.531.531,0,0,1,8.792,45.4ZM.583,44.825H8.744V41.574H.583Z" transform="translate(0 -21.398)"/><path d="M39.272,45.4H31.015a.531.531,0,0,1-.535-.526V41.526A.531.531,0,0,1,31.015,41h8.257a.531.531,0,0,1,.54.526v3.347a.531.531,0,0,1-.54.526Zm-8.209-.574h8.161V41.574H31.063Z" transform="translate(-15.908 -21.398)"/><path d="M18.615,31.276a.33.33,0,0,1-.115,0,.3.3,0,0,1-.153-.378l5.794-13.7a.287.287,0,1,1,.526.225L18.878,31.1A.292.292,0,0,1,18.615,31.276Z" transform="translate(-9.565 -8.873)"/><path d="M18.615,11.111a.3.3,0,0,1-.186-.067.287.287,0,0,1-.033-.406l5.79-6.88a.287.287,0,1,1,.44.368l-5.79,6.865A.292.292,0,0,1,18.615,11.111Z" transform="translate(-9.564 -1.908)"/><path d="M24.386,18.3a.282.282,0,0,1-.263-.177L18.348,4.444a.3.3,0,0,1,.153-.378.292.292,0,0,1,.378.153l5.79,13.668a.292.292,0,0,1-.263.4Z" transform="translate(-9.565 -2.111)"/><path d="M24.364,38.095a.3.3,0,0,1-.225-.105l-5.79-7.171a.287.287,0,0,1,.445-.363l5.794,7.171a.287.287,0,0,1-.225.478Z" transform="translate(-9.543 -15.84)"/></svg>,
    helpVideo: '448967522',
    settings: {
      sections: [
        {
          headline: 'Titel',
          fields: [
            {
              type: 'switch',
              name: 'box_show',
              label: 'Anzeigen',
              defaultValue: true
            },
            {
              type: 'text',
              name: 'box_headline',
              label: 'Titel'
            },
            {
              type: 'textarea',
              name: 'box_text',
              label: 'Text'
            }
          ]
        },
        {
          headline: 'Lernzielkontrolle',
          description: 'Prüfungsfragen sind für das Abschließen des WBTs relevant. Bei 66% richtig beantworteten Prüfungsfragen gilt das WBT als bestanden.',
          fields: [
            {
              type: 'switch',
              name: 'required_question',
              label: 'Prüfungsfrage'
            }
          ]
        },
        {
          description: 'Erstellen Sie die zueinander gehörigen Paare!',
          fields: [
            {
              type: 'repeater',
              name: 'pairs',
              label: 'Paare',
              addItemLabel: 'Paar hinzufügen',
              fields: [
                {
                  type: 'text',
                  name: 'text_1',
                  label: 'Text'
                },
                {
                  type: 'text',
                  name: 'text_2',
                  label: 'Text'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                },
                {
                  settings: {}
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'slide_control',
    itemType: 'element',
    category: 'quiz',
    title: 'Schieberegler',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="32" height="7.184" viewBox="0 0 32 7.184"><path d="M19.74,5.77H38.694a.385.385,0,1,0,0-.77H19.753Z" transform="translate(-7.079 -1.793)"/><path d="M6.17,5.77H.385a.385.385,0,0,1,0-.77H6.158Z" transform="translate(0 -1.793)"/><path d="M12.612,7.184A3.592,3.592,0,1,1,16.2,3.592a3.592,3.592,0,0,1-3.592,3.592Zm0-6.414a2.822,2.822,0,1,0,2.809,2.822A2.822,2.822,0,0,0,12.612.77Z" transform="translate(-3.234)"/></svg>,
    helpVideo: '448967642',
    settings: {
      sections: [
        {
          headline: 'Titel',
          fields: [
            {
              type: 'switch',
              name: 'box_show',
              label: 'Anzeigen',
              defaultValue: true
            },
            {
              type: 'text',
              name: 'box_headline',
              label: 'Titel'
            },
            {
              type: 'textarea',
              name: 'box_text',
              label: 'Text'
            }
          ]
        },
        {
          headline: 'Bild',
          fields: [
            {
              type: 'image',
              name: 'image',
              label: 'Bild'
            }
          ]
        },
        {
          headline: 'Punkte',
          fields: [
            {
              type: 'text',
              name: 'point_left',
              label: 'linker Punkt'
            },
            {
              type: 'text',
              name: 'point_right',
              label: 'rechter Punkt'
            }
          ]
        }
      ]
    }
  }
]

if(process.env.REACT_APP_CLIENT !== 'aciso') {
  config.push(
    {
      type: 'tabs',
      itemType: 'element',
      category: 'content',
      title: 'Tabs',
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g transform="translate(-9467 11248)"><g transform="translate(9467 -11246.613)"><g><path id="Pfad_1005" data-name="Pfad 1005" d="M22.777,21.227H1.223A1.223,1.223,0,0,1,0,20.022V2.481A2.485,2.485,0,0,1,2.481,0H8.026a2.485,2.485,0,0,1,2.481,2.481V4.992H24V20.022a1.223,1.223,0,0,1-1.223,1.206ZM2.481.609A1.876,1.876,0,0,0,.609,2.481V20.022a.614.614,0,0,0,.614.614H22.777a.614.614,0,0,0,.614-.614V5.6H9.9V2.481A1.876,1.876,0,0,0,8.026.609Z" /><path id="Pfad_1006" data-name="Pfad 1006" d="M17.471,5.223h-.609V3.351A1.876,1.876,0,0,0,14.99,1.48H9.928L9.493.871h5.5a2.485,2.485,0,0,1,2.481,2.481Z" /><path id="Pfad_1007" data-name="Pfad 1007" d="M24,6.094h-.609V3.351A1.876,1.876,0,0,0,21.519,1.48h-6.8V.871h6.8A2.485,2.485,0,0,1,24,3.351Z" /><path id="Pfad_1008" data-name="Pfad 1008" d="M17.985,17.41H3.917a.3.3,0,1,1,0-.609H17.985a.3.3,0,1,1,0,.609Z" /><path id="Pfad_1009" data-name="Pfad 1009" d="M13.632,13.554H3.917a.3.3,0,0,1,0-.609h9.715a.3.3,0,0,1,0,.609Z" /><path id="Pfad_1010" data-name="Pfad 1010" d="M20.161,9.693H3.917a.3.3,0,0,1,0-.609H20.161a.3.3,0,1,1,0,.609Z" /></g></g></g></svg>,
      settings: {
        sections: [
          {
            fields: [
              {
                type: 'repeater',
                name: 'tabs',
                label: 'Tabs',
                addItemLabel: 'Tab hinzufügen',
                fields: [
                  {
                    type: 'textarea',
                    name: 'headline',
                    label: 'Titel'
                  },
                  {
                    type: 'wysiwyg',
                    name: 'text',
                    label: 'Text'
                  }
                ],
                defaultValue: [
                  {
                    settings: {}
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  )
  config.push(
    {
      type: 'scrollable_text',
      itemType: 'element',
      category: 'content',
      title: 'Scrollable Text',
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rechteck_373" data-name="Rechteck 373" width="24" height="24" transform="translate(9467 -11248)" fill="#fff"/>
          </clipPath>
        </defs>
        <g id="Gruppe_maskieren_23" data-name="Gruppe maskieren 23" transform="translate(-9467 11248)" clip-path="url(#clip-path)">
          <g id="Ebene_2" data-name="Ebene 2" transform="translate(9467 -11246.629)">
            <g id="Ebene_1" data-name="Ebene 1">
              <path id="Pfad_994" data-name="Pfad 994" d="M8.291,16.122H.322a.322.322,0,1,1,0-.645H8.291a.322.322,0,0,1,0,.645Z" fill="#fc45f0"/>
              <path id="Pfad_995" data-name="Pfad 995" d="M8.291,11.055H.322a.322.322,0,0,1,0-.645H8.291a.322.322,0,1,1,0,.645Z" fill="#fc45f0"/>
              <path id="Pfad_996" data-name="Pfad 996" d="M15.2,20.834H.322a.322.322,0,1,1,0-.645H15.2a.322.322,0,0,1,0,.645Z" fill="#fc45f0"/>
              <path id="Pfad_997" data-name="Pfad 997" d="M12.9,6.03H.322a.322.322,0,1,1,0-.645H12.9a.322.322,0,0,1,0,.645Z" fill="#fc45f0"/>
              <path id="Pfad_998" data-name="Pfad 998" d="M15.2,1.023H.322a.322.322,0,1,1,0-.645H15.2a.322.322,0,0,1,0,.645Z" fill="#fc45f0"/>
              <path id="Pfad_999" data-name="Pfad 999" d="M20.728,20.963a.322.322,0,0,1-.322-.322V.626a.322.322,0,0,1,.645,0V20.641a.322.322,0,0,1-.322.322Z" fill="#fc45f0"/>
              <path id="Pfad_1000" data-name="Pfad 1000" d="M20.728,21.258a.852.852,0,0,1-.728-.4l-2.354-2.764a.324.324,0,1,1,.493-.419l2.4,2.837a.207.207,0,0,0,.184.106.2.2,0,0,0,.18-.106l.032-.046,2.372-2.791a.327.327,0,0,1,.461-.037.322.322,0,0,1,.037.461l-2.354,2.764a.843.843,0,0,1-.728.4Z" fill="#fc45f0"/>
              <path id="Pfad_1001" data-name="Pfad 1001" d="M23.676,3.8a.327.327,0,0,1-.249-.12L20.945.76a.221.221,0,0,0-.216-.115.216.216,0,0,0-.2.115l-.037.046L18.061,3.685a.324.324,0,1,1-.493-.419L20,.41a.871.871,0,0,1,1.479,0L23.92,3.275a.322.322,0,0,1-.037.461.318.318,0,0,1-.207.069Z" fill="#fc45f0"/>
            </g>
          </g>
        </g>
      </svg>,
      settings: {
        sections: [
          {
            fields: [
              {
                type: 'wysiwyg',
                name: 'text',
                label: 'Text'
              }
            ]
          }
        ]
      }
    }
  )
  config.push(
    {
      type: 'flashcards',
      itemType: 'element',
      category: 'content',
      title: 'Flashcards / Memorycards',
      icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
        <g transform="translate(-9467 11248)">
          <g transform="translate(9467 -11246.555)">
            <g>
              <path d="M23.209,21.111H13.451a.791.791,0,0,1-.791-.787V8.085a.791.791,0,0,1,.791-.791h9.757A.791.791,0,0,1,24,8.085V20.323a.787.787,0,0,1-.791.787ZM13.451,7.885a.2.2,0,0,0-.2.2V20.323a.2.2,0,0,0,.2.191h9.757a.2.2,0,0,0,.2-.192V8.085a.2.2,0,0,0-.2-.2Z" />
              <path d="M20.387,17.991H15.932a.3.3,0,0,1,0-.6h4.455a.3.3,0,0,1,0,.6Z" />
              <path d="M19.149,14.591H15.932a.3.3,0,0,1,0-.6h3.217a.3.3,0,0,1,0,.6Z" />
              <path d="M20.634,11.187h-4.7a.3.3,0,1,1,0-.6h4.7a.3.3,0,1,1,0,.6Z" />
              <path d="M10.166,21.111H.8a.787.787,0,0,1-.8-.787V8.085a.791.791,0,0,1,.791-.791h9.362a.791.791,0,0,1,.8.791V20.323a.791.791,0,0,1-.791.787ZM.8,7.885a.2.2,0,0,0-.209.2V20.323a.2.2,0,0,0,.2.191h9.362a.191.191,0,0,0,.191-.191V8.085a.2.2,0,0,0-.192-.2Z" />
              <path d="M.506,11.7a.3.3,0,0,1-.213-.511L4,7.481a.3.3,0,1,1,.426.426l-3.715,3.7A.285.285,0,0,1,.506,11.7Z" />
              <path d="M.506,15.532a.294.294,0,0,1-.213-.085.3.3,0,0,1,0-.426l7.545-7.54a.3.3,0,0,1,.426,0,.294.294,0,0,1,0,.426L.715,15.447a.281.281,0,0,1-.209.085Z" />
              <path d="M.506,19.37a.315.315,0,0,1-.213-.085.3.3,0,0,1,0-.426L10.14,9.017a.3.3,0,0,1,.426.426L.715,19.285a.3.3,0,0,1-.209.085Z" />
              <path d="M2.809,20.906A.3.3,0,0,1,2.6,20.4l7.545-7.545a.3.3,0,0,1,.426,0,.294.294,0,0,1,0,.426l-7.549,7.54a.285.285,0,0,1-.209.089Z" />
              <path d="M6.647,20.906a.3.3,0,0,1-.213-.511l3.706-3.706a.3.3,0,0,1,.426,0,.294.294,0,0,1,0,.426L6.86,20.821a.3.3,0,0,1-.213.085Z" />
              <path d="M6.443,4.281l-.549-.234a6.63,6.63,0,0,1,12.2-.03l-.549.238a6.034,6.034,0,0,0-11.1.03Z" />
              <path d="M18.064,4.468h-.115l-2.068-.226a.3.3,0,0,1,.064-.591l2.047.221L17.77,1.826a.3.3,0,1,1,.6-.064l.221,2.068a.532.532,0,0,1-.145.489.523.523,0,0,1-.379.149Z" />
            </g>
          </g>
        </g>
      </svg>,
      settings: {
        sections: [
          {
            fields: [
              {
                type: 'repeater',
                name: 'cards',
                label: 'Karten',
                addItemLabel: 'Karte hinzufügen',
                fields: [
                  {
                    type: 'textarea',
                    name: 'headline_front',
                    label: 'Titel (Vorderseite)'
                  },
                  {
                    type: 'wysiwyg',
                    name: 'text_front',
                    label: 'Text (Vorderseite)'
                  },
                  {
                    type: 'textarea',
                    name: 'headline_back',
                    label: 'Titel (Rückseite)'
                  },
                  {
                    type: 'wysiwyg',
                    name: 'text_back',
                    label: 'Text (Rückseite)'
                  }
                ],
                defaultValue: [
                  {
                    settings: {}
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  )
  config.push(
    {
      type: 'image_zoom',
      itemType: 'element',
      category: 'content',
      title: 'Image Zoom',
      icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
        <g transform="translate(-9467 11248)" clip-path="url(#clip-path)">
          <g transform="translate(9467 -11247.191)">
            <g>
              <path d="M10.378,13.345c.191.04.382.067.573.089l-.413.413L6.426,17.959a.653.653,0,0,1-.919,0L4.214,16.667a.182.182,0,0,0-.258,0l-3.4,3.4-.067.071L.155,19.8l.4-.4,3.069-3.064a.657.657,0,0,1,.924,0l1.288,1.288a.182.182,0,0,0,.262,0Z" />
              <path d="M.488,20.259l-.444-.444L3.6,16.263a.759.759,0,0,1,1.048,0L5.933,17.55A.107.107,0,0,0,6,17.582a.089.089,0,0,0,.062-.027l4.317-4.317h.049c.178.036.364.062.568.084h.182l-4.69,4.7a.764.764,0,0,1-1.052,0L4.152,16.729a.107.107,0,0,0-.133,0Zm-.2-.444.2.2h0l3.4-3.4a.28.28,0,0,1,.386,0l1.292,1.292a.577.577,0,0,0,.795,0l4.4-4.4-.351-.058-4.25,4.25a.266.266,0,0,1-.191.075.258.258,0,0,1-.2-.075L4.481,16.418a.577.577,0,0,0-.8,0Z" />
              <path d="M16.431,16.924l-.329.329-3.824-3.819c.2-.022.386-.049.577-.089Z" />
              <path d="M16.089,17.382l-4-4h.182c.2-.022.391-.049.568-.084h.044l.036.031,3.642,3.642ZM12.457,13.5l3.633,3.628.2-.2-3.482-3.482Z" />
              <path d="M16.431,11.631v.493l-.444.466v-.515a5.507,5.507,0,0,0,.444-.444Z" />
              <path d="M15.885,12.808v-.773l.031-.027a3.5,3.5,0,0,0,.444-.444l.151-.164v.751Zm.178-.688v.258l.289-.289v-.24c-.093.093-.191.182-.289.271Z" />
              <path d="M16.431,13.6v8.038a.653.653,0,0,1-.653.653H.742a.653.653,0,0,1-.653-.653V9.1a.648.648,0,0,1,.653-.662H5.076a3.768,3.768,0,0,0,.124.444H.759a.182.182,0,0,0-.187.182V21.641a.187.187,0,0,0,.187.187H15.787a.187.187,0,0,0,.187-.187V13.132Z" />
              <path d="M15.787,22.382H.742A.742.742,0,0,1,0,21.641V9.1a.742.742,0,0,1,.742-.737H5.147v.067a3.56,3.56,0,0,0,.12.444l.036.115H.742a.093.093,0,0,0-.1.093V21.641a.1.1,0,0,0,.1.1H15.787a.1.1,0,0,0,.1-.1V12.919l.644.644v8.078a.742.742,0,0,1-.742.742ZM.742,8.54a.564.564,0,0,0-.564.56V21.641a.564.564,0,0,0,.564.564H15.787a.564.564,0,0,0,.564-.564V13.647l-.289-.289v8.282a.275.275,0,0,1-.275.275H.742a.275.275,0,0,1-.275-.275V9.1a.275.275,0,0,1,.275-.271H5.08c-.027-.1-.053-.191-.075-.289Z" />
              <path d="M11.609.089A6.923,6.923,0,0,0,4.836,8.438a3.782,3.782,0,0,0,.12.444A6.941,6.941,0,0,0,9.983,13.74c.187.044.369.08.555.107a6.857,6.857,0,0,0,2.145,0c.187-.027.369-.062.551-.107a7.048,7.048,0,0,0,1.91-.777,7.145,7.145,0,0,0,.844-.582c.16-.133.315-.271.466-.417A6.919,6.919,0,0,0,11.609.089Zm1.235,13.256c-.191.04-.382.067-.577.089a6.271,6.271,0,0,1-.657.031,4.653,4.653,0,0,1-.657-.031c-.213-.031-.382-.049-.573-.089a6.453,6.453,0,1,1,2.465,0Z"  stroke="#f644eb" stroke-miterlimit="10" stroke-width="0.178"/>
              <line y2="6.688" transform="translate(11.609 3.668)"/>
              <rect width="0.178" height="6.688" transform="translate(11.52 3.668)" />
              <rect width="0.466" height="6.688" transform="translate(11.378 3.668)" />
              <path d="M11.933,10.445h-.644V3.579h.644Zm-.466-.178h.289V3.757h-.289Z" />
              <line x2="6.688" transform="translate(8.265 7.012)"/>
              <rect width="6.688" height="0.178" transform="translate(8.265 6.923)" />
              <rect width="6.688" height="0.466" transform="translate(8.265 6.777)" />
              <path d="M15.041,7.332H8.176V6.688h6.866ZM8.353,7.154h6.51V6.866H8.353Z" />
              <path d="M17.253,10.658l-2.22,2.22.1.1.853.813.444.471,5.222,5.214,2.22-2.22ZM16.431,13.6l-.728-.724.271-.271.457-.484.813-.813,5.951,5.951-1.55,1.554Z"  stroke="#f644eb" stroke-miterlimit="10" stroke-width="0.178"/>
            </g>
          </g>
        </g>
      </svg>,
      settings: {
        sections: [
          {
            fields: [
              {
                type: 'image',
                name: 'image',
                label: 'Bild'
              }
            ]
          }
        ]
      }
    }
  )
  config.push(
    {
      type: 'process',
      itemType: 'element',
      category: 'content',
      title: 'Prozess',
      icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
        <g transform="translate(-9467 11248)">
          <g transform="translate(9467 -11247.551)">
            <g>
              <path d="M8.664,15.991,6.838,14.166H1.055A1.055,1.055,0,0,1,0,13.111V1.055A1.055,1.055,0,0,1,1.055,0H22.834a1.06,1.06,0,0,1,1.055,1.055V13.111a1.06,1.06,0,0,1-1.055,1.055H10.494ZM1.055.6a.46.46,0,0,0-.46.46V13.111a.46.46,0,0,0,.46.46h6.03l1.579,1.579,1.579-1.579H22.834a.46.46,0,0,0,.46-.46V1.055a.464.464,0,0,0-.46-.46Z" />
              <path d="M13.519,10.549H4.013a.3.3,0,0,1,0-.6h9.506a.3.3,0,1,1,0,.6Z" />
              <path d="M19.9,7.234H4.013a.3.3,0,1,1,0-.6H19.9a.3.3,0,0,1,0,.6Z" />
              <path d="M16.923,3.983H4.013a.3.3,0,1,1,0-.6H16.923a.3.3,0,1,1,0,.6Z" />
              <path d="M8.809,23.1a2.426,2.426,0,1,1,2.426-2.426A2.426,2.426,0,0,1,8.809,23.1Zm0-4.255a1.83,1.83,0,1,0,1.83,1.83A1.83,1.83,0,0,0,8.809,18.847Z" />
              <path d="M16.043,22.251a1.574,1.574,0,1,1,1.574-1.574A1.574,1.574,0,0,1,16.043,22.251Zm0-2.553a.979.979,0,1,0,.979.979.979.979,0,0,0-.979-.979Z" />
              <path d="M1.574,22.251a1.574,1.574,0,1,1,1.574-1.574,1.574,1.574,0,0,1-1.574,1.574Zm0-2.553a.979.979,0,1,0,.979.979.979.979,0,0,0-.979-.979Z" />
              <path d="M22.426,22.251A1.574,1.574,0,1,1,24,20.677,1.574,1.574,0,0,1,22.426,22.251Zm0-2.553a.979.979,0,1,0,.979.979.979.979,0,0,0-.979-.979Z" />
              <rect width="3.83" height="0.596" transform="translate(2.851 20.379)" />
              <rect width="3.83" height="0.596" transform="translate(10.936 20.379)" />
              <rect width="3.83" height="0.596" transform="translate(17.319 20.379)" />
            </g>
          </g>
        </g>
      </svg>,
      settings: {
        sections: [
          {
            fields: [
              {
                type: 'repeater',
                name: 'steps',
                label: 'Schritte',
                addItemLabel: 'Schritt hinzufügen',
                fields: [
                  {
                    type: 'image',
                    name: 'image',
                    label: 'Bild'
                  },
                  {
                    type: 'textarea',
                    name: 'headline',
                    label: 'Titel'
                  },
                  {
                    type: 'textarea',
                    name: 'text',
                    label: 'Text'
                  }
                ],
                defaultValue: [
                  {
                    settings: {}
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  )
  config.push(
    {
      type: 'interactive_video',
      itemType: 'element',
      category: 'content',
      title: 'Interaktives Video',
      icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="29" height="29" viewBox="0 0 29 29">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rechteck_388" data-name="Rechteck 388" width="29" height="29" transform="translate(9467 -11248)" fill="#fff"/>
          </clipPath>
        </defs>
        <g id="Gruppe_maskieren_31" data-name="Gruppe maskieren 31" transform="translate(-9467 11248)" clip-path="url(#clip-path)">
          <g id="Ebene_2" data-name="Ebene 2" transform="translate(9467 -11245.025)">
            <g id="Ebene_1" data-name="Ebene 1">
              <path id="Pfad_1046" data-name="Pfad 1046" d="M8.349,13.951a.455.455,0,0,1-.24-.066.476.476,0,0,1-.24-.414V7.5a.48.48,0,0,1,.72-.414l4.319,3a.48.48,0,0,1,.219.414.488.488,0,0,1-.24.414l-4.3,2.975a.455.455,0,0,1-.24.066ZM8.436,7.7v5.581l4.022-2.793Zm4.137,2.867Zm0-.149Z" transform="translate(1.493 1.333)" fill="#f644eb"/>
              <rect id="Rechteck_389" data-name="Rechteck 389" width="22.648" height="0.579" transform="translate(0.29 3.918)" fill="#f644eb"/>
              <path id="Pfad_1047" data-name="Pfad 1047" d="M20.542,19.6H1.163a.583.583,0,0,1-.583-.567V1.163A.583.583,0,0,1,1.163.579h20.9a.583.583,0,0,1,.583.583V13.384l.579.24V1.163A1.163,1.163,0,0,0,22.065,0H1.163A1.163,1.163,0,0,0,0,1.163V19.032a1.163,1.163,0,0,0,1.163,1.163H20.782Z" fill="#f644eb"/>
              <path id="Pfad_1048" data-name="Pfad 1048" d="M19.148,20.849A.616.616,0,0,1,19,20.829a.563.563,0,0,1-.414-.414L14.262,9.985a.575.575,0,0,1,.137-.579.559.559,0,0,1,.546-.149L25.458,13.6a.567.567,0,0,1,.232.939l-.046.037-2.354,1.6L25.8,18.681,23.691,20.8l-2.516-2.511-1.63,2.4a.559.559,0,0,1-.4.17ZM14.841,9.832l4.307,10.414,1.94-2.867,2.6,2.6,1.291-1.295-2.6-2.6,2.9-1.957h0Z" transform="translate(2.701 1.753)" fill="#f644eb"/>
            </g>
          </g>
        </g>
      </svg>,
      settings: {
        sections: [
          {
            fields: [
              {
                type: 'video',
                name: 'video',
                label: 'Video'
              },
              {
                type: 'textarea',
                name: 'text',
                label: 'Text',
              },
              {
                type: 'repeater',
                name: 'answers',
                label: 'Antworten',
                addItemLabel: 'Antwort hinzufügen',
                v2: true,
                allowCollapse: true,
                fields: [
                  {
                    type: 'textarea',
                    name: 'answer',
                    label: 'Antwort'
                  },
                  {
                    type: 'video',
                    name: 'video',
                    label: 'Video'
                  },
                  {
                    type: 'textarea',
                    name: 'text',
                    label: 'Text',
                  },
                  {
                    type: 'repeater',
                    name: 'answers',
                    label: 'Antworten',
                    addItemLabel: 'Antwort hinzufügen',
                    v2: true,
                    allowCollapse: true,
                    fields: [
                      {
                        type: 'textarea',
                        name: 'answer',
                        label: 'Antwort'
                      },
                      {
                        type: 'video',
                        name: 'video',
                        label: 'Video'
                      },
                      {
                        type: 'textarea',
                        name: 'text',
                        label: 'Text',
                      },
                      {
                        type: 'repeater',
                        name: 'answers',
                        label: 'Antworten',
                        addItemLabel: 'Antwort hinzufügen',
                        v2: true,
                        allowCollapse: true,
                        fields: [
                          {
                            type: 'textarea',
                            name: 'answer',
                            label: 'Antwort'
                          },
                          {
                            type: 'video',
                            name: 'video',
                            label: 'Video'
                          },
                          {
                            type: 'textarea',
                            name: 'text',
                            label: 'Text',
                          },
                          {
                            type: 'repeater',
                            name: 'answers',
                            label: 'Antworten',
                            addItemLabel: 'Antwort hinzufügen',
                            v2: true,
                            allowCollapse: true,
                            fields: [
                              {
                                type: 'textarea',
                                name: 'answer',
                                label: 'Antwort'
                              },
                              {
                                type: 'video',
                                name: 'video',
                                label: 'Video'
                              },
                              {
                                type: 'textarea',
                                name: 'text',
                                label: 'Text',
                              },
                              {
                                type: 'repeater',
                                name: 'answers',
                                label: 'Antworten',
                                addItemLabel: 'Antwort hinzufügen',
                                v2: true,
                                allowCollapse: true,
                                fields: [
                                  {
                                    type: 'textarea',
                                    name: 'answer',
                                    label: 'Antwort'
                                  },
                                  {
                                    type: 'video',
                                    name: 'video',
                                    label: 'Video'
                                  },
                                  {
                                    type: 'textarea',
                                    name: 'text',
                                    label: 'Text',
                                  },
                                ],
                                defaultValue: []
                              }
                            ],
                            defaultValue: []
                          }
                        ],
                        defaultValue: []
                      }
                    ],
                    defaultValue: []
                  }
                ],
                defaultValue: [
                  {
                    settings: {}
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  )
  config.push(
    {
      type: 'profile',
      itemType: 'element',
      category: 'quiz',
      title: 'Profil',
      icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
        <g transform="translate(-181 -551.969)">
          <g transform="translate(181 554.053)">
            <g>
              <path d="M5.969,13.126H.7a.289.289,0,0,1,0-.578H5.969a.289.289,0,0,1,0,.578Z" />
              <path d="M7.5,7.875H.7A.289.289,0,0,1,.7,7.3H7.5a.289.289,0,1,1,0,.578Z" />
              <path d="M8.712,18.563H.7a.289.289,0,1,1,0-.578H8.712a.289.289,0,1,1,0,.578Z" />
              <path d="M11.7,19.829a.289.289,0,0,1-.289-.289V2.888a.289.289,0,0,1,.578,0V19.541a.289.289,0,0,1-.289.289Z" />
              <path d="M17.144,8.663H14.925a.413.413,0,0,1-.413-.413V6.229a.413.413,0,0,1,.413-.413h2.219a.413.413,0,0,1,.413.413V8.25A.413.413,0,0,1,17.144,8.663Zm-2.063-.578H17V6.377H15.073Z" />
              <path d="M23.711,2.694H.289a.289.289,0,0,1,0-.578H23.711a.289.289,0,1,1,0,.578Z" />
              <path d="M16.913.578H15.139a.289.289,0,1,1,0-.578h1.774a.289.289,0,1,1,0,.578Z" />
              <path d="M22.276.578H20.5A.289.289,0,1,1,20.5,0h1.774a.289.289,0,1,1,0,.578Z" />
              <path d="M22.507,14.12H20.287a.413.413,0,0,1-.413-.413V11.682a.413.413,0,0,1,.413-.413h2.219a.413.413,0,0,1,.413.413v2.009a.413.413,0,0,1-.413.429Zm-2.063-.578h1.914V11.831H20.436Z" />
              <path d="M17.144,19.8H14.925a.413.413,0,0,1-.413-.413V17.367a.413.413,0,0,1,.413-.413h2.219a.413.413,0,0,1,.413.413v2.021A.413.413,0,0,1,17.144,19.8Zm-2.063-.578H17V17.515H15.073Z" />
              <path d="M15.873,13.918,14.85,12.891a.285.285,0,0,1,0-.413.293.293,0,0,1,.413,0l.619.619,1.444-1.44a.292.292,0,1,1,.413.413Z" />
              <path d="M20.824,19.281,19.8,18.254a.285.285,0,0,1,0-.413.293.293,0,0,1,.413,0l.619.619,1.444-1.44a.292.292,0,1,1,.413.413Z" />
              <path d="M20.824,8.143,19.8,7.116a.285.285,0,0,1,0-.413.293.293,0,0,1,.413,0l.619.619,1.444-1.44a.292.292,0,1,1,.413.413Z" />
            </g>
          </g>
        </g>
      </svg>,
      settings: {
        sections: [
          {
            headline: 'Titel',
            fields: [
              {
                type: 'switch',
                name: 'box_show',
                label: 'Anzeigen',
                defaultValue: true
              },
              {
                type: 'text',
                name: 'box_headline',
                label: 'Titel'
              },
              {
                type: 'textarea',
                name: 'box_text',
                label: 'Text'
              },
              {
                type: 'audio',
                name: 'box_audio',
                label: 'Audio'
              }
            ]
          },
          {
            headline: 'Bewertung',
            fields: [
              {
                type: 'repeater',
                name: 'ratings',
                label: 'Bewertungen',
                simplified: true,
                addItemLabel: 'Bewertung hinzufügen',
                maxItems: 5,
                fields: [
                  {
                    type: 'text',
                    name: 'text',
                    label: 'Text'
                  }
                ],
                defaultValue: [
                  {
                    settings: {}
                  }
                ]
              }
            ]
          },
          {
            headline: 'Reihen',
            fields: [
              {
                type: 'repeater',
                name: 'rows',
                label: 'Reihen',
                simplified: true,
                addItemLabel: 'Reihe hinzufügen',
                fields: [
                  {
                    type: 'text',
                    name: 'text',
                    label: 'Text'
                  }
                ],
                defaultValue: [
                  {
                    settings: {}
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  )
  config.push(
    {
      type: 'hotspots_quiz',
      itemType: 'element',
      category: 'quiz',
      title: 'Hotspot',
      icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
        <g transform="translate(-91 -272.969)">
          <g transform="translate(91 274.68)">
            <g>
              <path d="M11.723,11.462a5.731,5.731,0,1,1,5.731-5.731,5.731,5.731,0,0,1-5.731,5.731Zm0-10.854a5.123,5.123,0,1,0,5.123,5.123A5.123,5.123,0,0,0,11.723.608Z" />
              <path d="M11.627,8.249a.3.3,0,0,1-.3-.3V3.517a.3.3,0,0,1,.608,0V7.945a.3.3,0,0,1-.3.3Z" />
              <path d="M13.841,6.035H9.409a.3.3,0,1,1,0-.608h4.433a.3.3,0,1,1,0,.608Z" />
              <path d="M6.317,20.58H.673A.66.66,0,0,1,0,19.924V14.8a.66.66,0,0,1,.656-.656H6.3a.66.66,0,0,1,.656.656v5.123A.66.66,0,0,1,6.317,20.58ZM.656,14.762a.048.048,0,0,0-.048.048v5.123a.048.048,0,0,0,.048.048H6.3a.048.048,0,0,0,.048-.048V14.8a.048.048,0,0,0-.048-.048Z" />
              <path d="M14.567,20.58H8.922a.66.66,0,0,1-.673-.656V14.8a.66.66,0,0,1,.656-.656h5.644a.66.66,0,0,1,.656.656v5.123A.66.66,0,0,1,14.567,20.58ZM8.9,14.762a.048.048,0,0,0-.048.048v5.123a.048.048,0,0,0,.048.048h5.644a.048.048,0,0,0,.048-.048V14.8a.048.048,0,0,0-.048-.048Z" />
              <path d="M22.816,20.58H17.172a.66.66,0,0,1-.673-.656V14.8a.66.66,0,0,1,.656-.656H22.8a.66.66,0,0,1,.656.656v5.123A.66.66,0,0,1,22.816,20.58Zm-5.662-5.818a.048.048,0,0,0-.048.048v5.123a.048.048,0,0,0,.048.048H22.8a.048.048,0,0,0,.048-.048V14.8a.048.048,0,0,0-.048-.048Z" />
              <path d="M19.868,18.874l-1.945-1.8a.3.3,0,1,1,.412-.434L19.8,17.992l3.647-4.646a.308.308,0,0,1,.434-.052.3.3,0,0,1,.052.434Z" />
            </g>
          </g>
        </g>
      </svg>,
      settings: {
        sections: [
          {
            headline: 'Titel',
            fields: [
              {
                type: 'text',
                name: 'box_headline',
                label: 'Titel'
              },
              {
                type: 'textarea',
                name: 'box_text',
                label: 'Text'
              },
              {
                type: 'image',
                name: 'image',
                label: 'Bild'
              },
              {
                type: 'audio',
                name: 'box_audio',
                label: 'Audio'
              }
            ]
          },
          {
            headline: 'Hotspots',
            fields: [
              {
                type: 'repeater',
                name: 'hotspots',
                label: 'Hotspots',
                addItemLabel: 'Hotspot hinzufügen',
                fields: [
                  {
                    type: 'coordinates',
                    name: 'position',
                    label: 'Position',
                    defaultValue: {
                      x: '50',
                      y: '50'
                    }
                  },
                  {
                    type: 'textarea',
                    name: 'answer_1',
                    label: 'Antwort 1'
                  },
                  {
                    type: 'textarea',
                    name: 'answer_2',
                    label: 'Antwort 2'
                  },
                  {
                    type: 'textarea',
                    name: 'answer_3',
                    label: 'Antwort 3'
                  },
                  {
                    type: 'select',
                    name: 'solution',
                    label: 'Lösung',
                    options: [
                      {
                        value: '1',
                        name: 'Antwort 1'
                      },
                      {
                        value: '2',
                        name: 'Antwort 2'
                      },
                      {
                        value: '3',
                        name: 'Antwort 3'
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  )
  config.push(
    {
      type: 'chat_simulator',
      itemType: 'element',
      category: 'quiz',
      title: 'Chat Simulator',
      icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
        <g transform="translate(-181 -551.969)">
          <g transform="translate(181 553.271)">
            <g>
              <path d="M22.982,8.409H19.106V9h3.877a.458.458,0,0,1,.454.454v7.707a.454.454,0,0,1-.454.454H19.8v3.065a.13.13,0,0,1-.076.118.118.118,0,0,1-.139-.029l-3.153-3.153H11.554a.454.454,0,0,1-.454-.454V13.7h-.589v3.456A1.043,1.043,0,0,0,11.554,18.2h4.625l2.981,2.981a.7.7,0,0,0,.5.21.69.69,0,0,0,.273-.055.711.711,0,0,0,.42-.66V18.2h2.6A1.047,1.047,0,0,0,24,17.159V9.452A1.047,1.047,0,0,0,22.982,8.409Z" />
              <path d="M4.356,17.189a.69.69,0,0,1-.273-.055.711.711,0,0,1-.441-.66V14h-2.6A1.043,1.043,0,0,1,0,12.954V1.043A1.043,1.043,0,0,1,1.043,0H18.357A1.047,1.047,0,0,1,19.4,1.043V12.954A1.047,1.047,0,0,1,18.357,14H7.846L4.865,16.978a.711.711,0,0,1-.509.21ZM1.043.589a.454.454,0,0,0-.454.454V12.954a.454.454,0,0,0,.454.454H4.23v3.065a.122.122,0,0,0,.076.118.118.118,0,0,0,.139-.029L7.6,13.409h10.76a.454.454,0,0,0,.454-.454V1.043a.458.458,0,0,0-.454-.454Z" />
              <path d="M9.153,10.608H3.965a.294.294,0,0,1,0-.589H9.153a.294.294,0,1,1,0,.589Z" />
              <path d="M15.46,7.3H3.965a.294.294,0,0,1,0-.589h11.5a.294.294,0,1,1,0,.589Z" />
              <path d="M12.517,3.936H3.965a.294.294,0,0,1,0-.589h8.552a.294.294,0,1,1,0,.589Z" />
            </g>
          </g>
        </g>
      </svg>,
      settings: {
        sections: [
          {
            fields: [
              {
                type: 'textarea',
                name: 'message',
                label: 'Nachricht',
              },
              {
                type: 'repeater',
                name: 'answers',
                label: 'Antworten',
                addItemLabel: 'Antwort hinzufügen',
                v2: true,
                allowCollapse: true,
                fields: [
                  {
                    type: 'textarea',
                    name: 'answer',
                    label: 'Antwort'
                  },
                  {
                    type: 'textarea',
                    name: 'message',
                    label: 'Nachricht',
                  },
                  {
                    type: 'repeater',
                    name: 'answers',
                    label: 'Antworten',
                    addItemLabel: 'Antwort hinzufügen',
                    v2: true,
                    allowCollapse: true,
                    fields: [
                      {
                        type: 'textarea',
                        name: 'answer',
                        label: 'Antwort'
                      },
                      {
                        type: 'textarea',
                        name: 'message',
                        label: 'Nachricht',
                      },
                      {
                        type: 'repeater',
                        name: 'answers',
                        label: 'Antworten',
                        addItemLabel: 'Antwort hinzufügen',
                        v2: true,
                        allowCollapse: true,
                        fields: [
                          {
                            type: 'textarea',
                            name: 'answer',
                            label: 'Antwort'
                          },
                          {
                            type: 'textarea',
                            name: 'message',
                            label: 'Nachricht',
                          },
                          {
                            type: 'repeater',
                            name: 'answers',
                            label: 'Antworten',
                            addItemLabel: 'Antwort hinzufügen',
                            v2: true,
                            allowCollapse: true,
                            fields: [
                              {
                                type: 'textarea',
                                name: 'answer',
                                label: 'Antwort'
                              },
                              {
                                type: 'textarea',
                                name: 'message',
                                label: 'Nachricht',
                              },
                              {
                                type: 'repeater',
                                name: 'answers',
                                label: 'Antworten',
                                addItemLabel: 'Antwort hinzufügen',
                                v2: true,
                                allowCollapse: true,
                                fields: [
                                  {
                                    type: 'textarea',
                                    name: 'answer',
                                    label: 'Antwort'
                                  },
                                  {
                                    type: 'textarea',
                                    name: 'message',
                                    label: 'Nachricht',
                                  }
                                ],
                                defaultValue: []
                              }
                            ],
                            defaultValue: []
                          }
                        ],
                        defaultValue: []
                      }
                    ],
                    defaultValue: []
                  }
                ],
                defaultValue: [
                  {
                    settings: {}
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  )
}

const CONFIG_ELEMENTS = config

export default CONFIG_ELEMENTS
